import { z } from 'zod';
import { ADJUST_FIELDS } from './adjust-fields.js';
import { refineAdjustReason } from './refine-adjust-reason.js';
export const scrapInventoryInputSchema = z
    .object({
    requestId: ADJUST_FIELDS.requestId(),
    tagId: ADJUST_FIELDS.id('Stock'),
    quantity: ADJUST_FIELDS.quantity(),
    reasonId: ADJUST_FIELDS.reasonId(),
    note: ADJUST_FIELDS.note(),
})
    .superRefine((value, context) => refineAdjustReason(value, context, ['SCRAP']));
//# sourceMappingURL=scrap-input.js.map